import { getInstance } from "./authWrapper";

export const authGuard = (to, from, next) => {
    const authService = getInstance();
    const fn = async () => {
        // If the user is authenticated and admin, continue with the route
        if (authService.isAuthenticated) {
            return next()
        }

        // Otherwise, log in
        authService.loginWithRedirect({ appState: { targetUrl: to.fullpath } });
    };

    // If loading has already finished, check our auth state using `fn()`
    if (!authService.loading) {
        return fn();
    }

    // Watch for the loading property to change before we check isAuthenticated
    authService.$watch("loading", loading => {
        if (loading === false) {
            return fn();
        }
    });
};
